import React, { useEffect, useRef, useState } from 'react';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { Button, Icon, PaymentError } from 'lb-components';
import { Resend } from 'lb-components/src/stories/assets/icons/payment';


import classes from '../Manual.module.scss';
import { Loader } from '../../Loader';
import { useTranslation } from 'lb-store';

export default ({
  platform,
  submit,
  resend,
  onResend,
  smsError,
  loader,
  d,
  ...props
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState(smsError);
  const ref1 = useRef();
  const ref2 = useRef();
  //const [resendState, setResendState] = useState({ show: false });

  useEffect(() => {
    setError(smsError);
  }, [smsError]);

  return (
    <Row
      as={Form}
      noValidate
      autoComplete={'off'}
      className={"form-submit"}
      onSubmit={(e) => {
        e.preventDefault();
        if (isNaN(parseFloat(e.target.sms?.value))) {
          setError(t('INVALID_SMS'));
        } else {
          const result = submit({
            sms: e.target.sms.value,
          });
          //if result.error setError(result.error)
        }
      }}
    >
      <Col
        xs={5}
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: platform === 'web' ? 'flex-end' : 'flex-start',
          fontFamily: 'lbet-st',
          fontSize: '1.3rem',
          color: '#868895',
        }}
      >
        {t('შეიყვანეთ SMS კოდი')}
      </Col>
      <Col xs={4}>
        <Form.Group className={classes.formGroup}>
          {React.createElement(
            platform === 'web' ? React.Fragment : FloatingLabel,
            {
              ...(platform === 'mob' && {
                label: 'SMS',
                style: {
                  width: '100%',
                  color: '#868895',
                },
                autoFocus:true,
                autoComplete:'one-time-code',
                className: classes.floatingLabel,
              }
              ),
              ref:ref1
            },
            <>
              <Form.Control
                ref={ref2}
                name={'sms'}
                placeholder={'SMS'}
                autoFocus
                autoComplete={'one-time-code'}
                isInvalid={!!error}
                style={{ paddingRight: '2.7rem' }}
              />
              {/*--- resend confirmation sms button ---*/}
              {resend && (
                <Button
                  variant={'info'}
                  outline
                  style={{
                    position: 'absolute',
                    right: error ? '2.5rem' : '0.7rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 'fit-content',
                    border: 'none',
                    background: 'transparent',
                    padding: 0,
                  }}
                  onClick={()=>{
                     if(ref1?.current){
                       ref1.current.value=""
                        ref1.current.focus()
                     }
                    if(ref2?.current){
                      ref2.current.value=""
                      ref2.current.focus()
                    }
                    onResend()
                  }}
                >
                  <Icon
                    height={'2rem'}
                    width={'2rem'}
                    type={'vec'}
                    Icon={Resend}
                    style={{
                      backgroundColor: '#435fa0',
                    }}
                  />
                </Button>
              )}
            </>
          )}
          {platform === 'mob' && !!error && <Form.Label>{error}</Form.Label>}
        </Form.Group>

        {platform === 'web' && <PaymentError show={!!error} message={error} />}
      </Col>
      <Col xs={3}>
        <Button
          disabled={loader}
          variant={'secondary'}
          style={{
            backgroundColor: '#3E42B5',
            borderColor: '#3E42B5',
          }}
          type={'submit'}
        >
          <Loader loader={loader} />
          <span>{t('დასტური')}</span>
        </Button>
      </Col>
    </Row>
  );
};
